import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { NEXT_STEPS_SURVEY_API_NAMES } from 'ui-addon-upgrades/_core/common/constants/trials'; // @ts-expect-error ts-migrate(7016)

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import Tx120SurveyLoadingModal from './Tx120SurveyLoadingModal';
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY',
  TX_0120_LOADING_SURVEY: 'TX_0120_LOADING_SURVEY'
};

const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showIllustration,
  showTrialLoadingState,
  canViewNewSeats,
  isEligibleForTX0120,
  isTX0120Fetched,
  isTX0120Variant
}) => {
  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const shouldShowTx0120Survey = isTX0120Fetched && isEligibleForTX0120 && isTX0120Variant;
  const initialModal = shouldShowTx0120Survey ? SUCCESS_MODAL_TYPES.TX_0120_LOADING_SURVEY : SUCCESS_MODAL_TYPES.INITIAL_SUCCESS;
  const [successModalType, setSuccessModalType] = useState(initialModal);

  const maybeShowNextStepsSurvey = () => {
    const nextStepsIncludesProduct = NEXT_STEPS_SURVEY_API_NAMES.includes(apiNameToUse);
    const shouldShowNextStepsSurvey = nextStepsIncludesProduct && !shouldHideSurvey;

    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    } else if (onSuccess) {
      onSuccess();
    }
  };

  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats
      });

    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats
      });

    case SUCCESS_MODAL_TYPES.TX_0120_LOADING_SURVEY:
      {
        const onLoadingFinish = () => {
          setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
        };

        return /*#__PURE__*/_jsx(Tx120SurveyLoadingModal, {
          onLoadingFinish: onLoadingFinish,
          apiName: apiNameToUse
        });
      }

    default:
      return null;
  }
};

TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;